import { moneyMask, areaMask } from '@/shared/utils';

/** The dash shown wherever a metric is unknown or pending. */
export const PENDING_METRIC = '—';

/**
 * Formats a money amount with the same mask the price column uses, or the
 * pending dash when the value is null (unknown or not-yet-loaded).
 *
 * @param value - The amount in BRL, or null.
 * @returns The masked money string, or "—".
 */
export function formatMoney(value: number | null): string {
  if (value === null) return PENDING_METRIC;
  return moneyMask(value.toFixed(2)).masked;
}

/**
 * Formats an area with the same mask the área column uses, or the pending
 * dash when the value is null.
 *
 * @param value - The area in m², or null.
 * @returns The masked area string, or "—".
 */
export function formatArea(value: number | null): string {
  if (value === null) return PENDING_METRIC;
  return areaMask(value.toFixed(2)).masked;
}

/**
 * Computes a group's whole-number share of the portfolio.
 *
 * @param count - The group's property count.
 * @param total - The portfolio total.
 * @returns The rounded percentage (0 when the total is 0).
 */
export function portfolioShare(count: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((count / total) * 100);
}
